/* Glow on Tee — header behaviour.
   Mega menu: hover, click and keyboard. The mobile drawer is built from the same
   markup, so the menu is only maintained in one place. */
(function () {
  var root = document.querySelector('[data-gt-header]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('.gt-nav__item[data-menu]'));
  var closeTimer;

  function open(item) {
    items.forEach(function (i) { if (i !== item) close(i); });
    item.classList.add('is-open');
    item.querySelector('.gt-nav__link').setAttribute('aria-expanded', 'true');
  }
  function close(item) {
    item.classList.remove('is-open');
    item.querySelector('.gt-nav__link').setAttribute('aria-expanded', 'false');
  }
  function closeAll() { items.forEach(close); }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(item); });
    item.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 120); });
    item.querySelector('.gt-nav__link').addEventListener('click', function () {
      item.classList.contains('is-open') ? close(item) : open(item);
    });
    item.addEventListener('focusin', function () { clearTimeout(closeTimer); open(item); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close(item);
    });
  });

  var drawer = document.querySelector('[data-gt-drawer]');
  var scrim = document.querySelector('[data-gt-scrim]');
  var drawerNav = document.querySelector('[data-gt-drawer-nav]');

  if (drawerNav) {
    root.querySelectorAll('.gt-nav__item').forEach(function (item) {
      var trigger = item.querySelector('.gt-nav__link');
      var label = trigger.textContent.trim();
      var mega = item.querySelector('.gt-mega');

      if (!mega) {
        var a = document.createElement('a');
        a.className = 'gt-acc';
        a.href = trigger.getAttribute('href') || '#';
        a.style.display = 'block';
        a.style.padding = '16px 2px';
        a.textContent = label;
        drawerNav.appendChild(a);
        return;
      }

      var wrap = document.createElement('div');
      wrap.className = 'gt-acc';
      wrap.innerHTML =
        '<button class="gt-acc__btn" aria-expanded="false">' + label +
        '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 1l4 4 4-4"/></svg></button>' +
        '<div class="gt-acc__panel"></div>';

      var panel = wrap.querySelector('.gt-acc__panel');
      mega.querySelectorAll('.gt-col:not(.gt-promo-card)').forEach(function (col) {
        panel.appendChild(col.cloneNode(true));
      });

      wrap.querySelector('.gt-acc__btn').addEventListener('click', function () {
        var isOpen = wrap.classList.toggle('is-open');
        this.setAttribute('aria-expanded', String(isOpen));
      });

      drawerNav.appendChild(wrap);
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-gt-drawer-open]').forEach(function (b) {
    b.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-gt-drawer-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); closeDrawer(); }
  });
})();
